import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.integration', {
        url: '/integration',
        component: 'companyManageApplicationIntegrationDevelopersIntegration',
        resolve: {
            applicationHelpInfo,
        },
    });
}

/** @ngInject */
function applicationHelpInfo(appId, ApplicationsResource, companyId) {
    return ApplicationsResource.getApplicationHelpInfo(companyId, appId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/integration/application-integration.state.js